import Vue from 'vue'
import { hostsConfig } from 'init/config'

import withRender from './summary-dim-select-image.html'
import './summary-dim.scss'
import './summary-dim-select-image.scss'

export default withRender(Vue.extend({
  props: {
    values: {
      type: Array,
      default: () => []
    },
    headingLevel: { type: Number, default: 3 },
    label: { type: String }
  },
  methods: {
    imageUrl(imageId) {
      // tslint:disable-next-line:max-line-length
      return `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/custom-dim/${hostsConfig.siteKey}/${imageId}.png`
    }
  }
}))
